<script setup lang="ts">
// Shared shape for every small colored status/cadence badge in the admin
// views (#1616) — was hand-copied at four call sites (run-status and
// cadence-state pills on ProductOwnerRunCard.vue and
// AgentRepoProductOwner.vue, plus the source/Default pills on
// AdminAgentRepos.vue). Callers own the color; this owns the shape.
defineProps<{
  label: string
  colorClass: string
  title?: string
  dataTestid?: string
}>()
</script>

<template>
  <span class="text-xs rounded px-2 py-0.5 shrink-0" :class="colorClass" :title="title" :data-testid="dataTestid">{{
    label
  }}</span>
</template>
